export default "__VITE_ASSET__AF4KAoGm__"